import { useCallback, useState } from 'react';

export const useMainMenu = (isOpenDefault = false) => {
  const [isOpen, setIsOpen] = useState(isOpenDefault);
  const onToggle = useCallback(() => setIsOpen(!isOpen), [isOpen]);
  const onClose = useCallback(() => { setIsOpen(false); }, []);
  return {
    isOpen,
    onToggle,
    onClose,
  };
};
